import React, { useState, useEffect } from "react";
import axios from "axios";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PaginationLink from "../../components/Pagination/Pagination";
import DutySlipList from "../../components/DutySlipBook/DutySlipList";
import { DateRangePicker } from "react-date-range";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function DutySlip() {
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState();
  const [region, setRegion] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [dateRange, setDateRange] = useState("Execution Date");
  const [recordCount, setRecordCount] = useState(0);

  const [userDetailResponse, setUserDetailResponse] = useState([]); // ✅ for API data
  const [loading, setLoading] = useState(false);

  const baseAPI = process.env.REACT_APP_API_URL;
  const title = "Add";
  const heading = "Duty Slip Book";

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  useEffect(() => {
    setRegions();
    fetchDutySlip(); // ✅ Fetch on load
  }, []);

  const fetchDutySlip = async () => {
    try {
      setLoading(true);
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.get(
        "http://localhost:52712/api/userget/GetDutySlip",
        {
          headers: {
            Authorization: `Bearer ${storedToken}`, // if API needs token
          },
        }
      );
      if (response.data.status === "True") {
        setUserDetailResponse(response.data.data || []);
        setRecordCount(response.data.data.length);
      } else {
        setUserDetailResponse([]);
      }
    } catch (error) {
      console.error("Error fetching DutySlip:", error);
      setUserDetailResponse([]);
    } finally {
      setLoading(false);
    }
  };

  const GetId = (param) => {
    setSelectedEmployeeId(param);
  };

  function setRegions() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETRegion?region_id=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setRegion(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const togglePicker = () => {
    setDateRange(
      formatDate(selectionRange.startDate) +
        " - " +
        formatDate(selectionRange.endDate)
    );
    setIsOpen(!isOpen);
  };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges.selection);
  };

  const clearDateRange = () => {
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
  };

  const handleDownloadExcel = () => {
  if (!userDetailResponse || userDetailResponse.length === 0) {
    alert("No data available to download");
    return;
  }

  // Convert your data array to a worksheet
  const worksheet = XLSX.utils.json_to_sheet(userDetailResponse);

  // Create a workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "DutySlip");

  // Convert the workbook to a binary Excel file
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  // Create a Blob and trigger download
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `DutySlip_${new Date().toISOString().split("T")[0]}.xlsx`);
};

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Duty Slip Book | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Human Resources</span>{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Duty Slip Book</span>
                </h1>
              </div>
            </div>

            <div>
              <Wrapper className="ViewLeadDetails">
                <Wrapper className="ViewLeadDetails mb-2">
                  <div className="row">
                    <div className="col-2">
                      <div className="form-group mb-3">
                        {/* <label>Lead Id:</label> */}
                        <input
                          type="text"
                          className="form-control"
                          name="description"
                          // value={expenseCategoryData.description}
                          // onChange={handleChange}
                          placeholder="Lead Id"
                        />
                      </div>
                    </div>

                    <div className="col-3">
                      <div className="form-group mb-3">
                        {/* <label>Field Coordinatior</label> */}
                        <input
                          type="text"
                          className="form-control"
                          name="description"
                          // value={expenseCategoryData.description}
                          // onChange={handleChange}
                          placeholder="Field Coordinatior"
                        />
                      </div>
                    </div>

                    <div className="col-2">
                      <div className="form-group mb-3">
                        {/* <label>Execution Date:</label> */}
                        <div>
                          <button
                            style={{
                              marginBottom: "1rem",
                              //  width: "12rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              marginTop: "6px",
                              //  width: "8rem",
                            }}
                            onClick={togglePicker}
                          >
                            {" "}
                            <b> {dateRange}</b>
                          </button>
                          {isOpen && (
                            <div
                              style={{
                                position: "absolute",
                                zIndex: 999,
                                border: "solid 1px black",
                                marginLeft: "-13pc",
                                width: "35pc",
                                background: "white",
                              }}
                            >
                              <DateRangePicker
                                ranges={[selectionRange]}
                                onChange={handleSelect}
                              />
                              <button
                                onClick={clearDateRange}
                                style={{
                                  marginBottom: "1rem",
                                  width: "5rem",
                                  height: "2.5rem",
                                  borderRadius: "0.5rem",
                                  fontSize: "13px",
                                  position: "relative",
                                  top: "1px",
                                  left: "22pc",
                                  color: "red",
                                  border: "none",
                                }}
                              >
                                Reset
                              </button>
                              <button
                                style={{
                                  marginBottom: "1rem",
                                  width: "7rem",
                                  height: "2.5rem",
                                  borderRadius: "0.5rem",
                                  fontSize: "13px",
                                  position: "relative",
                                  top: "1px",
                                  left: "22pc",
                                  backgroundColor: "#5B489D",
                                  color: "White",
                                }}
                                onClick={togglePicker}
                              >
                                Done
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-5 d-flex justify-content-end"
                      style={{ padding: "6px 13px 0 15px" }}
                    >
                      <button
                        className="btn btn-primary"
                        style={{ margin: "0 7px 0 0" }}
                        onClick={() => {
                          // ✅ apply logic here
                          console.log("Applied:", selectionRange);
                          setIsOpen(false);
                        }}
                      >
                        Apply
                      </button>
                      <button
  className="btn btn-outline-secondary"
  onClick={handleDownloadExcel}
>
  <DownloadIcon className="icon" /> Download Excel
</button>
                    </div>
                  </div>
                </Wrapper>

                <h5 className="mt-4 ml-4">Duty Slip Book</h5>

                {/* ✅ Pass API data here */}
                <DutySlipList
                  userDetailResponse={userDetailResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={GetId}
                  openAddProfile={openAddProfile}
                  setOpenAddProfile={setOpenAddProfile}
                  loading={loading}
                />

                <PaginationLink />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DutySlip;
